import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import moment from "moment";
import Administration from "./components/Administration";
import KioskModeToggle from "./components/KioskModeToggle";
import KioskReportDialog from "./components/KioskReportDialog";
import Monitoring from "./components/Monitoring";
import { useKioskAdministrationData } from "./hooks/useKioskAdministrationData";
import { useKioskMonitoringData } from "./hooks/useKioskMonitoringData";

const initialFilters = () => ({
  fechaDesde: moment().format("YYYY-MM-DD"),
  fechaHasta: moment().endOf("isoWeek").format("YYYY-MM-DD"),
});

const Kiosk = () => {
  const role = Number(sessionStorage.getItem("satiRol"));
  if (role !== 2) return <Redirect to="/dashboard" />;
  return <KioskDashboard />;
};

const KioskDashboard = () => {
  const [activeMode, setActiveMode] = useState("administracion");
  const [filters, setFilters] = useState(initialFilters);
  const [reportSessionId, setReportSessionId] = useState(null);

  const administration = useKioskAdministrationData(filters, activeMode === "administracion");
  const monitoring = useKioskMonitoringData(filters, activeMode === "monitoreo");

  const onFilterChange = (key, value) => {
    setFilters(previous => ({
      ...previous,
      [key]: value,
      ...(key === "page" ? {} : { page: 1 }),
    }));
  };

  return (
    <main className="min-h-screen p-4 md:p-6 font-sans">
      <div className="max-w-[1600px] mx-auto space-y-5">
        <header className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0075AC] font-display">IBICARE · OPERACIÓN</p>
            <h1 className="mt-1 text-3xl md:text-4xl font-bold text-[#1D1F3F] font-display">KIOSK</h1>
            <p className="mt-2 text-sm text-slate-500">Administra sesiones programadas y monitorea las mediciones de tu empresa.</p>
          </div>
          <KioskModeToggle activeMode={activeMode} onChange={setActiveMode} />
        </header>

        {activeMode === "administracion" ? (
          <Administration
            data={administration.data}
            filters={filters}
            onFilterChange={onFilterChange}
            onReport={setReportSessionId}
            loading={administration.loading}
            error={administration.error}
            onReload={administration.reload}
          />
        ) : (
          <Monitoring
            data={monitoring.data}
            filters={filters}
            onFilterChange={onFilterChange}
            onReport={setReportSessionId}
            loading={monitoring.loading}
            error={monitoring.error}
            onReload={monitoring.reload}
          />
        )}

        <KioskReportDialog sessionId={reportSessionId} onClose={() => setReportSessionId(null)} />
      </div>
    </main>
  );
};

export { initialFilters };
export default Kiosk;
